import React from 'react';
import { chordNames } from '../chord-names';
import { Note } from '../models/Note';

interface ChordNamesProps {
  selectedNotes: Note[];
}

export const ChordNames: React.FunctionComponent<ChordNamesProps> = props => {
  const { selectedNotes } = props;
  const names = chordNames(selectedNotes);

  return (
    <div data-testid="chord-names" className="chord-names">
      {selectedNotes.length < 2 ? (
        <div className="message">Select some notes!</div>
      ) : names.length ? (
        names.map(name => (
          <div key={name} className="chord-name">
            {name}
          </div>
        ))
      ) : (
        <div className="message">No suitable chord names found!</div>
      )}
    </div>
  );
};
